const dateRe = new RegExp(
  /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:Z|[+-][01]\d:[0-5]\d)$/,
  'i'
);

function maybeParseDate(value: any) {
  if (typeof value === 'string' && dateRe.test(value)) {
    return new Date(value);
  }
  return value;
}

export function pluck<T, K extends keyof T>(input: T, ...keys: K[]): Pick<T, K> {
  return keys.reduce((out, key) => ({ ...out, [key]: maybeParseDate(input[key]) }), {} as Pick<T, K>);
}
